import { NgModule } from '@angular/core';
import { TagsSelectorComponent } from './tags-selector.component';

const MODULES = [TagsSelectorComponent];

@NgModule({
  declarations: [],
  imports: MODULES,
  exports: [...MODULES]
})
export class TagsSelectorModule {}
